import axios from "axios";
import router from "../../router"; // Lecture 364
import store from "../store";

const state = {
  userToken: null,
  userId: null,
  isAgent: null,
  isCandidate: null,
  isEmployer: null,
  // userProfile: null,
  agencyID: 33,
  agencyName: "TinyTreasuresNYC",
  agency: {},

  userProfile: {},

  stripeAccountID: "acct_1EBYhTFiJiOD1ROq" // TTNYC
};

const mutations = {
  authUser(state, userData) {
    console.log("Storing Authentication Data");
    state.userToken = userData.token;
    state.userId = userData.user_id;
    state.isAgent = userData.is_agent;
    state.isCandidate = userData.is_candidate;
    state.isEmployer = userData.is_employer;
  },
  storeUser(state, userData) {
    state.userProfile = userData;
  },
  clearAuthData(state) {
    state.userToken = null;
    // state.userProfile = null
    state.userId = null;
    state.isAgent = null;
    state.isCandidate = null;
    state.isEmployer = null;
  }
};

const actions = {
  tryAutoLogin({ commit }) {
    // Lecture 366
    const stored_token = localStorage.getItem("token");
    if (!stored_token) {
      return;
    }
    // const expirationDate = localStorage.getItem('expirationDate')
    // const now = new Date()
    // if (now >= expirationDate) {
    //   return
    // }
    let is_agent = false;
    let is_candidate = false;
    let is_employer = false;
    const stored_user_id = localStorage.getItem("user_id");
    const stored_is_agent = localStorage.getItem("is_agent");
    if (stored_is_agent === "true") {
      is_agent = true;
    }
    const stored_is_candidate = localStorage.getItem("is_candidate");
    if (stored_is_candidate === "true") {
      is_candidate = true;
    }
    const stored_is_employer = localStorage.getItem("is_employer");
    if (stored_is_employer === "true") {
      is_employer = true;
    }
    commit("authUser", {
      token: stored_token,
      user_id: stored_user_id,
      // is_agent: stored_is_agent,
      // is_candidate: stored_is_candidate,
      // is_employer: stored_is_employer,
      is_agent: is_agent,
      is_candidate: is_candidate,
      is_employer: is_employer
    });
  },
  registerUser({ commit, dispatch }, authData) {
    // https://vuex.vuejs.org/guide/actions.html
    // https://stackoverflow.com/questions/45848974/call-an-action-from-within-another-action
    return new Promise((resolve, reject) => {
      // axios.post('/optimum/create-user/', {
      axios
        .post("/create-user/", {
          email: authData.email,
          password: authData.password,
          agency: state.agencyID,
          // agency: 'ThriveHire', // The ThriveHire Agency object has an id of 4
          // user_type: authData.user_type,
          // status: authData.status,
          // status: 'New',
          // phone: authData.phone,
        })
        .then(res => {
          console.log("User resgistered!");
          console.log(res);
          console.log(res.data.pk);

          // dispatch('storeAuthentication', authData) // Lecture 360
          dispatch("login", authData) // Lecture 360
            // Need to run login immediately on registration, otherwise the following patch request will not be authenticated
            .then(() => {
              let is_agent = false;
              let is_candidate = false;
              let is_employer = false;
              if (authData.user_type == "agent") {
                this.is_agent = true;
              } else {
                this.is_agent = false;
              }
              if (authData.user_type == "candidate") {
                this.is_candidate = true;
                //                 dispatch('sendEmail', {
                //                   subject: 'Welcome',
                //                   message: '\
                // Welcome to ThriveHire!\n\n\
                // We\'re thrilled to have you joining our community! Through your account, you can start searching and applying to jobs, internships, events and more. For any queries, please email info@thrivehire.org and we\'ll be in touch with you shortly.\n\n\
                // Kind regards,\n\n\
                // The ThriveHire Team',
                //                   from: 'info@thrivehire.co',
                //                   email: authData.email,
                //                   reply: 'info@thrivehire.org',
                //                   userID: res.data.pk,
                //                 })
              } else {
                this.is_candidate = false;
              }

              if (authData.user_type == "employer") {
                this.is_employer = true;
                //                 dispatch('sendEmail', {
                //                   subject: 'Welcome',
                //                   message: '\
                // Welcome to ThriveHire!\n\n\
                // Thank you for joining our community. We’re looking forward to working with you and sharing your organization’s impactful work and opportunities.\n\n\
                // We would be happy to set up a short call with you to learn more about your needs, to highlight ways that ThriveHire may benefit you, and to clarify any questions you may have.\n\n\
                // Please schedule a time that is convenient for you for this call here: calendly.com/hmundeva/30min?back=1&month=2020-01\n\n\
                // We’re looking forward to speaking with you!\n\n\
                // Kind regards,\n\n\
                // Hayley Mundeva\n\
                // Founder/CEO, ThriveHire',
                //                   from: 'info@thrivehire.co',
                //                   email: authData.email,
                //                   reply: 'hmundeva@thrivehire.org',
                //                   userID: res.data.pk,
                //                 })
                // dispatch('sendEmail', {
                //   subject: 'New Employer Registration',
                //   message: 'New Employer Email: '+authData.email,
                //   from: 'info@thrivehire.co',
                //   // email: 'aakash@enginehire.ca',
                //   email: 'info@thrivehire.org',
                //   reply: 'info@thrivehire.org',
                //   userID: 4,
                // })
              } else {
                this.is_employer = false;
              }
              console.log(this.is_agent);
              console.log(this.is_candidate);
              console.log(this.is_employer);
              axios
                .patch("/api/people/".concat(res.data.pk.toString()) + "/", {
                  agency: state.agencyID,
                  agency_owner: state.agencyName,
                  // user_type: authData.user_type,
                  is_employer: this.is_employer,
                  is_candidate: this.is_candidate,
                  is_agent: this.is_agent,
                  // status: 'New',
                  status: authData.status
                  // numberArray: [0, 0, 0, 0],
                })
                .then(res => {
                  console.log(res);

                  dispatch("login", authData) // Lecture 360
                    // Once the user's type and agency is set, run log in again
                    .then(() => {
                      resolve();
                    });
                })
                .catch(error => console.log(error));

              // this.testAction

              // resolve()
            });
        })
        // Problem with registering the user, probably because the email is already in use
        .catch(error => {
          console.log(error);
          reject(); // https://forum.vuejs.org/t/resolving-promises/1007
        });
    });
  },
  storeAuthentication({ commit, dispatch }, authData) {
    // https://vuex.vuejs.org/guide/actions.html
    // https://stackoverflow.com/questions/45848974/call-an-action-from-within-another-action
    return new Promise((resolve, reject) => {
      localStorage.setItem("token", res.data.token); // Lecture 366
      localStorage.setItem("user_id", res.data.user_id);
      localStorage.setItem("is_agent", res.data.is_agent);

      resolve();
    });
  },
  login({ commit, dispatch }, authData) {
    // https://vuex.vuejs.org/guide/actions.html
    // https://stackoverflow.com/questions/45848974/call-an-action-from-within-another-action
    return new Promise((resolve, reject) => {
      axios
        .post("/api-token-auth/", {
          username: authData.email,
          password: authData.password,
          agency: state.agencyID,
        })
        .then(res => {
          // console.log("Successful Login");
          console.log(res);

          // Need to check if the person logging in actually belongs to this agency
          // If it is a new registration then their agency ID defaults to 1
          if (res.data.agency_id === 1 || res.data.agency_id == state.agencyID) {
            // state.isCandidate = res.data.is_candidate
            // state.isEmployer = res.data.is_employer
            commit("authUser", {
              token: res.data.token,
              user_id: res.data.user_id,
              is_agent: res.data.is_agent,
              is_candidate: res.data.is_candidate,
              is_employer: res.data.is_employer
            });
            // Need to save both of these for the authUser mutation
            localStorage.setItem("token", res.data.token); // Lecture 366
            localStorage.setItem("user_id", res.data.user_id);
            localStorage.setItem("is_agent", res.data.is_agent);
            localStorage.setItem("is_candidate", res.data.is_candidate);
            localStorage.setItem("is_employer", res.data.is_employer);

            axios
              .get("/api/agencies?id=" + state.agencyID)
              .then(res => {
                state.agency = res.data;
              })
              .catch(error => console.log(error));

            // const now = new Date()
            // const expirationDate = new Date(now.getTime() + 3600000) // Covert the date to milliseconds, add an hour, then convert back to a date
            // localStorage.setItem('expirationDate', expirationDate)
            resolve();
            // dispatch('getUser') // Once someone logs in get their user profile, update: don't need to, can just call getUser from the user profile component
            // dispatch('setLogoutTimer') // If we want to auto log people out - Lecture 365, this is less relevant since the DRF token doesn't have an expiration
            console.log("Redirection after logging in");
            console.log(res.data.is_candidate);
            console.log(res.data.is_employer);
            if (res.data.is_candidate && !authData.user_type) {
              // Don't want to redirect on registration
              // router.replace('/user')
              router.replace({ name: "Candidate Dashboard" });
            }
            if (res.data.is_employer && !authData.user_type) {
              // Don't want to redirect on registration
              // router.replace('/organization')
              router.replace({ name: "Employer Dashboard" });
            }
            if (res.data.is_agent) {
              // router.replace('/agent-dashboard')
              router.replace({ name: "Agent Dashboard" });
            }
          }
          else {
            // If someone has logged in with a different agency's account
            reject() // https://forum.vuejs.org/t/resolving-promises/1007
          }
        })
        // Problem logging in, likely incorrect email or password, or account doesn't exist
        .catch(error => {
          console.log(error);
          reject(); // https://forum.vuejs.org/t/resolving-promises/1007
        });
    });
  },
  logout({ commit }, redirect) {
    commit("clearAuthData");
    // router.replace('/login') // After someone logs out send them to the login page - Lecture 364
    // router.push({name: 'Login'}) // https://router.vuejs.org/guide/essentials/navigation.html
    if (redirect != "no-redirect") {
      router.push({ name: "Login" }); // https://router.vuejs.org/guide/essentials/navigation.html
    }

    // When someone logs out we want to clear their auth details from the browser, so they have to log back in - Lecture 366
    // localStorage.removeItem('expirationDate')
    localStorage.removeItem("token");
    localStorage.removeItem("user_id");
    localStorage.removeItem("is_agent");
  },
  test({ commit }) {
    console.log("Test successful.");
  }
};

const getters = {
  // user (state) {
  //   return state.userProfile
  // },
  userID(state) {
    return state.userId;
  },
  isAuthenticated(state) {
    return state.userToken !== null;
  },
  isAgent(state) {
    return state.isAgent;
  },
  isCandidate(state) {
    return state.isCandidate;
  },
  isEmployer(state) {
    return state.isEmployer;
  },
  userAPIURL(state) {
    return "/api/people/".concat(state.userId.toString()).concat("/");
  },
  agencyID(state) {
    return state.agencyID;
  },
  agencyName(state) {
    return state.agencyName;
  },
  agency(state) {
    return state.agency;
  },
  stripeAccountID(state) {
    return state.stripeAccountID;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./src/store/modules/authentication.js